export const UploadStatus = {
    IDLE: 'idle',
    READY: 'ready',
    VALIDATING: 'validating',
    UPLOADING: 'uploading',
}

export const ResultStatus = {
    NONE: 'none',
    SUCCESS: 'success',
    ERROR: 'error',
}
